import pageType from 'Addons/search/pageType.ts';
import {
  getPageType as getShopifyPageType,
  getSearchPageUrl,
  isInDesignMode,
  getThemeInfo,
} from './helpers.ts';

const shopifyToConvermaxPageTypeMap = {
  home: pageType.home,
  collection: pageType.category,
  vendors: pageType.brand,
  product: pageType.product,
};

function getPageType() {
  const pageTypeShopify = getShopifyPageType();
  if (pageTypeShopify) {
    return shopifyToConvermaxPageTypeMap[pageTypeShopify] || pageType.unknown;
  }

  console.warn('Page type not found');
  return pageType.unknown;
}

getPageType.defaults = { getter: getPageType };

export default {
  searchPageUrl: getSearchPageUrl(),
  page: { getPageType },
  isInDesignMode,
  themeInfo: getThemeInfo(),
};
